import { useParams } from "react-router-dom";
import { useAnimation } from "../hooks/useAnimation";
import { useEffect } from "react";
import { render } from 'storyblok-rich-text-react-renderer';

const BlogDetail = () => {
    const { index } = useParams();
    const animate = useAnimation();

    const newsItem = sessionStorage.getItem('news')
    let newsDetail = null;


    if (newsItem && index) {
        newsDetail = JSON.parse(newsItem)[index]
    } else {
        const loadNews = async () => {
            try {

                const url = window.location.href.split('/')[2];
                const response = await fetch(`https://api.storyblok.com/v2/cdn/stories/?version=${url === 'fiyuu.com.tr' ? 'published' : 'draft'}&token=PU48xeT0YARVgQPLiYGmwAtt`)

                const data = await response.json()
                let works = null;
                let newsies: any = [];

                data.stories.forEach((element: any) => {
                    if (element.full_slug.indexOf('haber-ve-blog') > -1) {
                        newsies.push(element)

                    }
                });
                data.stories.forEach((element: any) => {
                    if (element.slug.indexOf('is-ilanlari') > -1) {
                        works = element

                    }
                });

                sessionStorage.setItem('news', JSON.stringify(newsies));
                sessionStorage.setItem('works', JSON.stringify(works));
                const DetailItem = Number(window.location.href.split('/').pop())
                newsDetail = newsies.stories[DetailItem]
                window.location.reload();
            } catch (error) {
            }
        }
        useEffect(() => {
            loadNews()
        }, [])
    }
    useEffect(() => {
        animate()
        window.scrollTo(0, 0);
    }, [])
    return (
        newsDetail &&
        <div className="blog-detail-ctr d-flex justify-content-center flex-column align-items-center">
            <div className="w-100 d-flex flex-column justify-content-center align-items-center">
                <div className="page-banner-secondary w-100 d-flex justify-content-center align-items-center">
                    <div className="page-container d-flex flex-column justify-content-center align-items-center">
                        <div className="image d-flex justify-content-center align-items-center" data-animation="zoomIn" data-animation-delay="50ms">
                            <img src={newsDetail.content.img} alt="" />
                        </div>
                        <h1 className="title mb-5" data-animation="zoomIn" data-animation-delay="50ms">
                            {newsDetail.content.title}
                        </h1>
                        <p className="sub-info" data-animation="zoomIn" data-animation-delay="50ms">
                            {newsDetail.content.topic}
                        </p>
                    </div>
                </div>

                <div className="blog-inner page-container pt-5 d-flex flex-column justify-content-start align-items-start">
                    <div className="blog-content w-100 d-flex flex-column justify-content-start align-items-start" data-animation="zoomIn" data-animation-delay="50ms">
                        <div className="blog-text">
                            {render(newsDetail.content.content)}
                        </div>


                    </div>
                    <div className="content-bottom ellipse" data-animation="zoomIn" data-animation-delay="50ms">
                        <div className="ellipse"></div>
                        <div className="ellipse"></div>
                        <div className="ellipse"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BlogDetail;